import React from 'react';
import Acord28Form from './Acord28Form';
import type { Acord28FormRef } from './Acord28Form';

export type { Acord28FormRef };

// Every prop the plain form takes, minus the one this wrapper sets. Spreading them keeps the
// "+ ACORD 101" variant in lockstep with the base form: before this, the wrapper re-listed the
// props by hand and silently dropped onLoadingChange, onCoverageMapping and friends, so on a
// +101 form the parent never learned which policies mapped (every policy looked unmapped) and
// the Loading state could never clear.
type Acord28With101FormProps = Omit<React.ComponentPropsWithoutRef<typeof Acord28Form>, 'showAcord101'>;

const Acord28With101Form = React.forwardRef<Acord28FormRef, Acord28With101FormProps>(
  function Acord28With101Form(props, ref) {
    return <Acord28Form ref={ref} showAcord101 {...props} />;
  }
);

export default Acord28With101Form;
